<template>
  <main class="main-content">
    <slot />
  </main>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.main-content {
  max-width: 96rem;
  padding: var(--site-padding);
}
</style>
